<script setup lang="ts">
import { ref, onErrorCaptured } from 'vue'

const error = ref<Error | null>(null)
const retryCount = ref(0)
const MAX_RETRIES = 2

onErrorCaptured((err) => {
  const e = err instanceof Error ? err : new Error(String(err))
  const msg = e.message || ''

  // Chunk load error: auto-reload the page to get fresh assets
  if (
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('ChunkLoadError') ||
    msg.includes('Loading chunk') ||
    msg.includes('Loading CSS chunk')
  ) {
    if (retryCount.value < MAX_RETRIES) {
      retryCount.value++
      console.warn(`[ErrorBoundary] Chunk load error, reloading page (attempt ${retryCount.value})`)
      if (typeof window !== 'undefined') {
        window.location.reload()
      }
      return false
    }
  }

  error.value = e
  console.error('[ErrorBoundary] Captured error:', e)
  return false
})

function retry() {
  error.value = null
  retryCount.value = 0
}
</script>

<template>
  <div v-if="error" class="p-md bg-feedback-danger/10 border border-feedback-danger rounded-md">
    <p class="text-feedback-danger text-sm font-bold mb-sm">页面出现错误</p>
    <p class="text-text-secondary text-xs mb-md">{{ error.message }}</p>
    <button
      class="text-brand-primary text-sm font-bold"
      @click="retry"
    >
      重试
    </button>
  </div>
  <slot v-else />
</template>
